<template>
  <div v-show="show"
       class="flex-tool header_fixed-tool"
       ref="tool"
       @mousedown="handleMouseDown($event)"
       @mouseup="handleMouseUpHand($event)"
       @click="onClick">
    <div class="text">使用评价</div>
    <i class="layout layout-pingjia"></i>
  </div>
</template>

<script>
  export default {
    name: 'comment-wrapper',
    data () {
      return {
        show: false,
        position: {
          x: null,
          y: null
        }
      }
    },
    computed: {
      menus () {
        return this.$store.getters.menus
      }
    },
    destroyed() {
      window.onmousemove = null
    },
    watch: {
      $route (val) {
        this.show = !!this.menus[val.path]
      }
    },
    methods: {
      onClick () {
        this.isClick && this.$emit('click')
      },
      handleMouseDown (event) {
        this.firstTime = new Date().getTime()
        this.position.y = event.pageY - this.$refs.tool.offsetTop
        event.currentTarget.style.cursor = 'move'
        window.onmousemove = this.handleMouseMove
      },
      handleMouseMove (event) {
        let moveTop = event.pageY - this.position.y
        let windowClientWidth = document.documentElement.clientWidth
        let windowClientHight = document.documentElement.clientHeight
        let limitX = windowClientWidth - this.$refs.tool.offsetWidth
        // 鼠标禁止移出容器
        if (event.pageX < limitX && window.onmousemove) {
          window.onmousemove = null
          this.$refs.tool.style.cursor = 'pointer'
          return
        }
        // 处理边界
        let toolOffsetHeight = this.$refs.tool.offsetHeight
        let KyeHeaderHeight = document.querySelector('.kye-header-panel').clientHeight
        if (moveTop <= KyeHeaderHeight + toolOffsetHeight) {
          moveTop = KyeHeaderHeight + toolOffsetHeight
        }
        if (moveTop >= windowClientHight - toolOffsetHeight) {
          moveTop = windowClientHight - toolOffsetHeight
        }
        this.$refs.tool.style.top = moveTop + 'px'
      },
      handleMouseUpHand (event) {
        window.onmousemove = null
        event.currentTarget.style.cursor = 'pointer'
        this.lastTime = new Date().getTime()
        // 解决 mousedown 和 click 事件冲突
        this.isClick = this.lastTime - this.firstTime < 200
      }
    }
  }
</script>

<style lang="scss" scope>
.header_fixed-tool {
  position: fixed;
  top: 50%;
  right: 0;
  justify-content: center;
  background: var(--g-color-primary);
  height: 30px !important;
  width: 22px;
  overflow: hidden;
  padding: 0 !important;
  transition: width .5s;
  border-radius: 4px 0px 0px 4px;
  box-sizing: border-box;
  .text{
    width: 0;
    text-align: center;
    white-space: nowrap;
    transition: width .5s;
    overflow: hidden;
  }
  &:hover{
    .text {
      width: 70px;
    }
    width: 74px;
    background: var(--g-color-primary) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/comment.vue